export default "__VITE_ASSET__DPSVKh9F__"